export const BREAKPOINTS = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl",
    "xxxl",
];
//# sourceMappingURL=breakpoints.js.map